import * as React from "react";
const EthicalSourceSVG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={56}
    height={56}
    fill="none"
    {...props}
  >
    <rect
      width={48}
      height={48}
      x={4}
      y={4}
      fill="#EF4136"
      fillOpacity={0.03}
      rx={24}
    />
    <rect
      width={48}
      height={48}
      x={4}
      y={4}
      stroke="#EF4136"
      strokeOpacity={0.06}
      strokeWidth={8}
      rx={24}
    />
    <path
      fill="#EF4136"
      d="m39.995 23.444-6.563-6.562a.876.876 0 0 0-1.238 0L18.059 31.016a4.897 4.897 0 1 0 6.926 6.926l12.238-12.238 2.43-.81a.875.875 0 0 0 .342-1.449Zm-16.248 13.26a3.147 3.147 0 0 1-4.45-4.45l3.15-3.15c.927-.317 2.38-.437 4.274.547 1.16.606 2.207.875 3.123.955l-6.097 6.098Zm12.727-12.596a.876.876 0 0 0-.343.211l-4.328 4.328c-.926.317-2.379.438-4.273-.547-1.16-.606-2.207-.875-3.124-.955l8.407-8.407 4.943 4.942-1.282.428Z"
    />
  </svg>
);
export default EthicalSourceSVG;
